import { createTheme } from '@mui/material/styles';

import { textColor } from '@/styles/colorPalette';

export const theme = createTheme({
  spacing: 4,
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    fontSize: 14,
    h1: {
      fontSize: 24,
      fontWeight: 700,
      lineHeight: '33px',
      letterSpacing: '0.3px',
    },
  },
  palette: {
    text: {
      primary: textColor,
    },
  },
  components: {
    MuiContainer: {
      defaultProps: {
        disableGutters: true,
        maxWidth: false,
      },
    },
  },
});
